// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__1zZbF","text":"footer_text__yEHa1"};